<template>
  <v-container fluid fill-height class="loginOverlay">
    <v-layout flex align-center justify-center>
      <v-flex xs12 md6 lg4 elevation-6>
        <v-toolbar class="pa-4 tool-bar-app darken-1">
          <v-layout justify-center align-center style="height: 100%;">
            <img class="login--logo" src="@/assets/imagens/logo_mono_cp.png" alt="Logo siged">
          </v-layout>
        </v-toolbar>
        <v-card>
          <v-card-text class="pt-4">
            <v-form @submit.prevent="alterar" ref="form">
              <Validator style="width: 100%;" :v="$v.senha">
                <v-text-field type="password" :min="8" prepend-icon="lock" name="senha" v-model="senha" required label="Digite sua nova senha"/>
              </Validator>
              <Validator style="width: 100%;" :v="$v.senha2" >
                <v-text-field type="password" :min="8" prepend-icon="lock" name="senha2" v-model="senha2" required label="Repita sua nova senha"/>
              </Validator>
              <v-alert
                :value="message"
                :type="messageType"
                transition="scale-transition"
              >
                {{message}}
              </v-alert>
              <v-btn :loading="sending" type="submit" class="accent white--text rounded-sm font-weight-regular">
                Alterar minha senha
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import authRepository from '@/repositories/authRepository.js';
import {
  required,
  minLength,
  sameAs,
} from 'vuelidate/lib/validators';
export default {
  data(){
    return {
      token: this.$route.params.token,
      senha: null,
      senha2: null,
      sending: false,
      message: null,
      messageType: null
    };
  },
  validations(){
    return {
      senha: {
        required,
        minLength : minLength(8)
      },
      senha2: {
        required,
        sameAs: sameAs('senha'),
        minLength : minLength(8)
      }
    }
  },
  methods: {
    async alterar(){

      this.$v.$touch();
      if (this.$v.$invalid) { return; }

      if (this.senha !== this.senha2){
        this.message = 'As senhas não são iguais! Digite a mesma senha duas vezes.';
        this.messageType = 'warning';
        return;
      }
      this.sending = true;
      try {
        const response = await authRepository.novaSenha(this.token, this.senha);

        this.message = response.data.message;
        this.messageType = 'success';
        setTimeout(() => this.$router.push('/login'), 3000);
      } catch (error) {
        this.message = error.response.data.errorMessage;
        this.messageType = 'error';
      }
      finally{
        this.sending = false;
        return;
      }
    },
  },
  watch: {
    message(){
      if (this.message)
        setTimeout(() => this.message = null, 4000);
    }
  }
}
</script>

<style lang="scss" scoped>
.loginOverlay {
  background-image: url("~@/assets/login-bg.png");
  background-repeat: repeat;
}

.login--logo {
  height: 100%;
}

.w100{
  width: 100;
}

</style>
